const data = [
  {
    title: 'MOST CREATIVE PEOPLE IN BUSINESS',
    description:
      'Leaders who are shaping the future of business in creative ways.',
    logo:
      'https://images.fastcompany.net/image/upload/h_70,f_auto,q_auto,fl_lossy/v1512595155/fcweb/mcp-logo-140_w6dozo.png',
    image:
      'https://images.fastcompany.net/image/upload/h_475,f_auto,q_auto,fl_lossy/v1513181808/fcweb/p-1-Most-Creative-People-2017-Donald-Glover_w0ekjo.jpg',
    link: 'https://www.fastcompany.com/most-creative-people/2017'
  },
  {
    title: 'INNOVATION by design',
    description:
      'The best products, services, interfaces, and design ideas in business.',
    logo:
      'https://images.fastcompany.net/image/upload/h_70,f_auto,q_auto,fl_lossy/v1512595155/fcweb/ibd-logo-140_xdn5xi.png',
    image:
      'https://images.fastcompany.net/image/upload/h_475,f_auto,q_auto,fl_lossy/v1513181808/fcweb/p-2-feature-219-Microsoft-rewrites-the-code_ttdxaq.jpg',
    link: 'https://www.fastcodesign.com/innovation-by-design/2017'
  },
  {
    title: 'Most Innovative Companies',
    description:
      'The top companies in entertainment, media, sports, technology, and more.',
    logo:
      'https://images.fastcompany.net/image/upload/h_70,f_auto,q_auto,fl_lossy/v1512595155/fcweb/mic-logo-140_ivn8bj.png',
    image:
      'https://images.fastcompany.net/image/upload/h_475,f_auto,q_auto,fl_lossy/v1519143105/fcweb/p-waze-mar-223-FA0318WAZE001_mg0zsj.jpg',
    link: 'https://www.fastcompany.com/most-innovative-companies/2018'
  },
  {
    title: 'World Changing Ideas',
    description:
      'Products, concepts, and policies that are pursuing innovation for good.',
    logo:
      'https://images.fastcompany.net/image/upload/h_70,f_auto,q_auto,fl_lossy/v1512595155/fcweb/wci-logo-140_vuva6d.png',
    image:
      'https://images.fastcompany.net/image/upload/h_475,f_auto,q_auto,fl_lossy/v1513181808/fcweb/3068717-poster-p-1-214-instagram-chris-paul-nba_ejg5fp.jpg',
    link: 'https://www.fastcompany.com/section/world-changing-ideas'
  }
];

export default data;



// WEBPACK FOOTER //
// ./src/views/components/franchise_showcase/franchise_data.js